export enum FeatureEnum {
  SCHEDULE_APPOINTMENT = 'schedule-appointment',
  RESERVATION = 'reservation',
  RESOURCE_RESERVATION_SCHEDULE = 'resource-reservation-schedule',
  CUSTOMER_RESERVATION_SCHEDULE = 'customer-reservation-schedule',
  CALENDAR_FOR_AN_INDIVIDUAL_RESOURCE = 'calendar-for-an-individual-resource',
  CALENDAR_USER = 'user-calendar',
  USER = 'user',
  WORK_HOURS = 'work-hours',
  RESOURCE_OCCUPANCY = 'report/resource-occupancy',
  SCHEDULE_FOR_AN_INDIVIDUAL_RESOURCE = 'schedule-for-an-individual-resource',
  JHI_USER = 'jhi-user',
  RESOURCE = 'resource',
  UTILITY = 'utility',
  ASSET = 'asset',
  CUSTOMER = 'customer',
  CUSTOMER_STATUS = 'customer-status',
  ROLE = 'role',
  APP_CONFIGURATION = 'app-configuration',
  RESERVATIONS_FOR_PERIOD = 'reservations-for-period',
}
